// extracted by mini-css-extract-plugin
module.exports = {"curvedFooterContainer":"curvedFooter_curvedFooterContainer__SGgfu","curve":"curvedFooter_curve__yxB4l"};